export default __webpack_public_path__ + "static/media/Calendar.576427cd.svg";